// Keep this in sync with Representation2dType in API
// TODO: Move to a better place
enum ShapeTypeEnum {
    NotDefined = "NotDefined",
    Shape = "Shape",
    Lineloops = "Lineloops",
    SvgSymbol = "SvgSymbol"
  }

export default ShapeTypeEnum;